module.exports = __webpack_public_path__ + "static/img/16.c347f71.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/eng/16.png
// module id = Sm7q
// module chunks = 0